import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  uploadImage,
  postTicket,
  getTicketInformations,
  handleOnClickLogout,
  urlHome,
} from "../constants";
import { NavBar, SideBar, Breadcrumb, UnderConstruction } from "../components";
import { LuContact, LuGitGraph, LuIdCard, LuPackage } from "react-icons/lu";
import { RxBackpack, RxExclamationTriangle } from "react-icons/rx";
import { FiExternalLink } from "react-icons/fi";
import { GrPlan } from "react-icons/gr";
import { AiOutlineMail } from "react-icons/ai";
import { TbBackground, TbDeviceDesktopAnalytics } from "react-icons/tb";
import { ToastContainer, toast } from "react-toastify";

const Support = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [categories, setCategories] = useState([
    "Cards",
    "Virtual Backgrounds",
    "Email Signatures",
    "Profiles",
    "Analytics",
    "Contacts",
    "Payments",
  ]);
  const [category, setCategory] = useState(categories[0]);
  const [desc, setDesc] = useState("");

  const handleChangeCategory = (e) => {
    e.preventDefault();
    setCategory(e.target.value);
  };

  const handleImageChange = (e) => {
    // Get the first file from the input selection
    const file = e.target.files[0];

    if (file && file.type.substring(0, 5) === "image") {
      // Create a URL for the file to use as the image source
      const reader = new FileReader();
      const objectUrl = URL.createObjectURL(file);
      reader.addEventListener("load", () => {
        const imageUrl = reader.result?.toString() || "";
        setImageSrc(imageUrl);
      });
      reader.readAsDataURL(file);
    } else {
      setImageSrc(null);
    }
  };

  const handleChangeDescription = (e) => {
    e.preventDefault();
    setDesc(e.target.value);
  };

  const handleSubmitTicket = async (e) => {
    e.preventDefault();
    setLoading(true);
    let ticket_images = [];
    let data = {
      category: category,
      description: desc,
    };
    if (imageSrc) {
      let image = {
        order_index: 1,
      };
      const image_id = await uploadImage(token, imageSrc, "ticket");
      if (image_id) {
        image["image_id"] = image_id;
        ticket_images.push(image);
      }
    }
    data["ticket_images"] = ticket_images;
    postTicket(
      token,
      data,
      setCategory,
      setDesc,
      setLoading,
      setImageSrc,
      fileInputRef,
    );
  };

  useEffect(() => {
    getTicketInformations(token, setCategories);
  }, []);

  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-start items-center text-secondary">
      <ToastContainer />
      <NavBar
        handleLogout={handleOnClickLogout}
        setLoading={setLoading}
        token={token}
      />
      <div className="flex flex-row w-full h-full">
        <SideBar active={"support"} />
        <div className="flex flex-col w-full">
          <Breadcrumb breads={["Support"]} />
          <div className="flex flex-col md:flex-row w-full h-full py-10 divide-x-[1px] gap-10 overflow-y-auto pb-52">
            <div className="flex flex-col w-full md:w-1/2 gap-10 px-10">
              <div className="text-[21px] font-bold text-black">
                Support Form
              </div>
              <div className="flex flex-col gap-5">
                <div className="flex flex-col gap-3">
                  <div className="font-semibold text-black">Category</div>
                  <select
                    id="categories"
                    className="bg-white border border-gray-400 text-gray-900 rounded-lg focus:ring-primary focus:border-primary block w-full px-5 py-3"
                    value={category}
                    onChange={handleChangeCategory}
                  >
                    {categories.map((val, ind) => (
                      <option key={ind} value={val}>
                        {val}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col gap-3">
                  <div className="font-semibold text-black">Message</div>
                  <textarea
                    name="issue"
                    id="issue"
                    className="border rounded-lg p-5 focus:outline-double outline-primary"
                    rows={10}
                    value={desc}
                    onChange={handleChangeDescription}
                  ></textarea>
                </div>
                <div className="flex flex-col gap-3">
                  <div className="font-semibold text-black">
                    Attachment (optional)
                  </div>
                  <input
                    accept="image/*"
                    name="file"
                    ref={fileInputRef}
                    id="file"
                    className="rounded-lg p-5 focus:outline-double outline-primary"
                    type="file"
                    onChange={handleImageChange}
                  />
                </div>
                <div className="flex flex-row w-full justify-end">
                  <div
                    className="py-3 px-10 bg-primary text-white rounded-lg hover:bg-secondary cursor-pointer"
                    onClick={handleSubmitTicket}
                  >
                    {loading ? (
                      <div role="status">
                        <svg
                          aria-hidden="true"
                          className="w-6 h-6 text-gray-200 animate-spin fill-secondary"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="white"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="#E47410"
                          />
                        </svg>
                        <span className="sr-only">Loading...</span>
                      </div>
                    ) : (
                      "Submit"
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-10 px-10 w-full md:w-1/2">
              <div className="text-[21px] font-bold text-black">Tutorial</div>
              <div className="flex flex-col md:flex-row p-5 border rounded-lg justify-between items-center shadow-sm">
                <div className="font-semibold text-black">
                  Want to know more about Nitomeyo? <br />
                  Explore about our capabilities in our blog
                </div>
                <a
                  className="flex flex-row items-center p-3 border rounded-lg hover:bg-gray-200 cursor-pointer gap-3"
                  href={`${urlHome}/blogs`}
                  target="_blank"
                >
                  Our blog <FiExternalLink />
                </a>
              </div>
              <div className="grid grid-cols-2 gap-5">
                <a
                  className="flex flex-col justify-center items-center gap-3 py-7 border rounded-lg hover:bg-primary hover:text-white cursor-pointer"
                  href={urlHome + "/blogs/search?q=package plan"}
                  target={"_blank"}
                >
                  <GrPlan />
                  <div>Package Plan</div>
                </a>
                <a
                  className="flex flex-col justify-center items-center gap-3 py-7 border rounded-lg hover:bg-primary hover:text-white cursor-pointer"
                  href={urlHome + "/blogs/search?q=card"}
                  target={"_blank"}
                >
                  <LuIdCard />
                  <div>Card</div>
                </a>
                <a
                  className="flex flex-col justify-center items-center gap-3 py-7 border rounded-lg hover:bg-primary hover:text-white cursor-pointer"
                  href={urlHome + "/blogs/search?q=email signature"}
                  target={"_blank"}
                >
                  <AiOutlineMail />
                  <div>Email Signature</div>
                </a>
                <a
                  className="flex flex-col justify-center items-center gap-3 py-7 border rounded-lg hover:bg-primary hover:text-white cursor-pointer"
                  href={urlHome + "/blogs/search?q=virtual background"}
                  target={"_blank"}
                >
                  <TbBackground />
                  <div>Virtual Background</div>
                </a>
                <a
                  className="flex flex-col justify-center items-center gap-3 py-7 border rounded-lg hover:bg-primary hover:text-white cursor-pointer"
                  href={urlHome + "/blogs/search?q=analytics"}
                  target={"_blank"}
                >
                  <TbDeviceDesktopAnalytics />
                  <div>Analytics</div>
                </a>
                <a
                  className="flex flex-col justify-center items-center gap-3 py-7 border rounded-lg hover:bg-primary hover:text-white cursor-pointer"
                  href={urlHome + "/blogs/search?q=contacts"}
                  target={"_blank"}
                >
                  <LuContact />
                  <div>Contacts</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
